import http from "../../http-common";
/**
 * Author : AndréK
 * 26/08/2022
*/

//Manufacturer
const createManufacturer = (data) => {
    return http.post("/Manufacturer/InsertManufacturer", data);
};

const getManufacturer = (data) => {
    return http.post("/Manufacturer/FilterManufacturer", data);
};

const updateManufacturer = (data) => {
    return http.post("/Manufacturer/UpdateManufacturer", data);
};

//Address
const createManufacturerAddress = (data) => {
    return http.post("/Manufacturer/InsertManufacturerAddress", data);
};

const getManufacturerAddress = (data) => {
    return http.post("/Manufacturer/FilterManufacturerAddress", data);
};

const updateManufacturerAddress = (data) => {
    return http.post("/Manufacturer/UpdateManufacturerAddress", data);
};

//Email
const createManufacturerEmail = (data) => {
    return http.post("/Manufacturer/InsertManufacturerEmail", data);
};

const getManufacturerEmail = (data) => {
    return http.post("/Manufacturer/FilterManufacturerEmail", data);
};

const updateManufacturerEmail = (data) => {
    return http.post("/Manufacturer/UpdateManufacturerEmail", data);
};

//Phone
const createManufacturerPhone = (data) => {
    return http.post("/Manufacturer/InsertManufacturerPhone", data);
};

const getManufacturerPhone = (data) => {
    return http.post("/Manufacturer/FilterManufacturerPhone", data);
};

const updateManufacturerPhone = (data) => {
    return http.post("/Manufacturer/UpdateManufacturerPhone", data);
};


export default {
    createManufacturer,
    getManufacturer,
    updateManufacturer,
    createManufacturerAddress,
    getManufacturerAddress,
    updateManufacturerAddress,
    createManufacturerEmail,
    getManufacturerEmail,
    updateManufacturerEmail,
    createManufacturerPhone,
    getManufacturerPhone,
    updateManufacturerPhone
};
